import React from "react";
import './case-study-end-screen.scss';
import SharedProfile from "../../../../../shared-storage/profile";
// import SharedStaticText from "../../../../../shared-storage/static-text-store";
import SharedThemeCategory from "../../../../../shared-storage/category-theme";
import { getImageSource, getThemeImageSource } from "../../../../utility/image-source";
import { ImageConstants } from "../../../../constants/constants";
import CwConfirmationModal from "../../../common/cw-confirmation-modal/cw-confirmation-modal";
// import Path from "../../../routes/routes-path";
import ViewAnswerTimer from "../../../my-classwork/view-answer-timer-popup-for-classwork/view-answer-timer";
import ChapterListPopup from "../../../my-classwork/chapter-list-popup/chapter-list-popup";
import ChapterAssessmentPerformanceReport from "../../../chapter-assessment-performance-report/chapter-assessment-performance-report";




export default class CaseStudyEndScreen extends React.Component {
    constructor(props) {
        super(props);

        this.meta = this.props.metaInfo
        this.chapterTitle = this.meta.chapterTitle;
        this.categoryThemeId = this.meta.categoryThemeId

        this.userInfo = SharedProfile.getProfile()
        this.theme = SharedThemeCategory.getThemeCategory(this.categoryThemeId)
    }

    state = {
        data: {
            markScored: '',
            notAttempted: '',
            timeTaken: '',
            correct: '',
            inCorrect: '',
            totalMark: '',

        },
        showPredictor: false,
        rangeText: ''
    }

    componentDidMount() {
    }


    handleBackButtonClick = () => {

        if (this.meta && this.meta.isFromMyHomework) {
            this.props.navigation.navigate('MyHomeworks')
            return
        }

        if (this.meta && this.meta.isExamPrepKit) {
            this.props.navigation.navigate('ExamPrepKitTableOfContent', {
                meta: {
                    chapterTitle: this.chapterTitle,
                    chapterKey: this.chapterKey,
                    categoryThemeId: this.categoryThemeId,
                    from: 'CHAPTERS_LIST'
                }
            });
            return;
        }
        this.props.navigation.navigate('MyAssessments')
        return true
    }



    closeViewAnswerPopup = () => {
        this.setState({ showViewAnswerPopUp: false })
    }

    getAssessmentStartingPoint = () => {
        return "Chapter Assessment"
    }


    toggleLateralMenu = () => {

        this.props.navigation.navigate('LateralMenu')
    }

    onPressCheckYourRank = () => {
        this.props.navigation.navigate('LeaderBoard', { meta: { eventId: this.meta.eventId } })
    }

    hideChaptersPopup = () => {
        this.setState({ showChaptersPopup: false })
    }

    showChaptersPopup = () => {
        this.setState({ showChaptersPopup: true })
    }

    getBorderColor = () => {


        if (this.state.data.percentage >= 0 && this.state.data.percentage <= 30) {
            return '#E96A6A'
        }

        if (this.state.data.percentage >= 31 && this.state.data.percentage <= 70) {
            return '#EEC865'
        }

        if (this.state.data.percentage >= 71 && this.state.data.percentage <= 100) {
            // return '#87CA9E'

            return '#0AC6D6'
        }

    }

    onPressContinue = () => {
        if (this.state.showPredictor) {
            let isTrial = this.userInfo.isPrepkitFreeUser

            let percentage = this.state.data.percentage
            let predictedScore = this.state.predictedScore


            // if (this.state.userExamPrepkitData && this.state.userExamPrepkitData.chapters && this.state.userExamPrepkitData.chapters.length && this.state.userExamPrepkitData.examDate) {
            //     this.props.navigation.navigate('PrepKitChapterList', { meta: { title: "Circles" } });

            // } else if (this.state.userExamPrepkitData && (!this.state.userExamPrepkitData.chapters || !this.state.userExamPrepkitData.chapters.length) && this.state.userExamPrepkitData.examDate) {
            //     this.props.navigation.navigate('ExamPrepKitChapterSelectionScreen')

            // }
            // // else if (this.state.userExamPrepkitData && this.state.userExamPrepkitData.chapters && this.state.userExamPrepkitData.chapters.length && !this.state.userExamPrepkitData.examDate) {
            // //     this.props.navigation.navigate('ExamDateCaptureScreen')
            // // }
            // else {

            this.props.navigation.navigate('ExamPrepKitIntroScreen', { meta: { from: "LANDING_SCREEN", showGuarantee: isTrial ? true : false, guaranteedScore: 10, percentage: percentage ? percentage : 5 } });
            // }



        } else {

            let revisionChapterKeys = []

            if (this.meta.selectedChapters && this.meta.selectedChapters.length) {
                for (let i = 0; i < this.meta.selectedChapters.length; i++) {
                    revisionChapterKeys.push(this.meta.selectedChapters[i].key)
                }

                this.props.navigation.navigate('RevisionChaptersList', { meta: { revisionChapterKeys: revisionChapterKeys } });
            } else if (this.meta.chapterKey) {

                let chapter = this.state.chapter

                //console.log(chapter)

                // if (chapter.status == constants.IS_CHAPTER_NOT_STARTED) {  
                //     this.toggleChapterCompletedModal(true, chapter.title, chapter.key, chapter.categoryId, chapter.lockedForTrial, chapter)   
                // } else {
                //     this.navigate(chapter.key,chapter.title,chapter.status == constants.IS_CHAPTER_NOT_COMPLETED ? true : false,chapter.categoryId,chapter.lockedForTrial,chapter)
                // }


            }

        }
    }


    goToHomeScreen() {

        return this.props.delegate && this.props.delegate.goToHomeScreen && this.props.delegate.goToHomeScreen()
    }

    goToClassworkListScreen() {
        return this.props.delegate && this.props.delegate.hideAssessmentEndScreen && this.props.delegate.hideAssessmentEndScreen()
    }



    showInsightsModal = () => {
        this.setState({ showInsights: true })
    }

    hideInsightsModal() {
        this.setState({ showInsights: false })
    }

    showPerformanceReport = () => {
        this.setState({ showPerformanceReport: true })
    }

    hideChapterAssessmentReport() {
        this.setState({ showPerformanceReport: false })
    }


    goToHomeScreen() {
        this.props.delegate && this.props.delegate.goToHomeScreen && this.props.delegate.goToHomeScreen()
    }

    goToPracticeQuestionsChapterList() {
        this.props.delegate && this.props.delegate.goToPracticeQuestionsChapterList && this.props.delegate.goToPracticeQuestionsChapterList()
    }

    goToPracticeList() {
        this.props.onSelectChapter && this.props.onSelectChapter({ key: this.meta.chapterKey, title: this.chapterTitle })
    }

    navigateToViewAnswer = () => {
        this.props.delegate && this.props.delegate.showViewAnswerScreen && this.props.delegate.showViewAnswerScreen({
            meta: {
                categoryThemeId: this.categoryThemeId,
                chapterTitle: this.chapterTitle,
                chapterKey: this.chapterKey,
                assessmentActivityId: this.assessmentActivityId,
                fromAssess: true,
                type: this.meta.type,
                from: this.meta && this.meta.from
            }
        })
    }

    goToSelectedChapter() {
        this.props.delegate && this.props.delegate.goToSelectedChapter && this.props.delegate.goToSelectedChapter()
    }

    goBackToTableOfContents = () => {
        this.props.caseStudyListDelegate && this.props.caseStudyListDelegate.goBackToTableOfContents && this.props.caseStudyListDelegate.goBackToTableOfContents()
    }

    goToExamPrepKit = () => {
        this.props.caseStudyListDelegate && this.props.caseStudyListDelegate.goToExamPrepKit && this.props.caseStudyListDelegate.goToExamPrepKit()
    }

    goToChapter = () => {
        this.props.caseStudyListDelegate && this.props.caseStudyListDelegate.goToChapter && this.props.caseStudyListDelegate.goToChapter()
    }

    goToHomeScreen = () => {
        this.props.caseStudyListDelegate && this.props.caseStudyListDelegate.goToHomeScreen && this.props.caseStudyListDelegate.goToHomeScreen()
    }



    renderBreadcrumb = () => {
        const chapterTitle = this.chapterTitle || 'Chapter';
        return (
            <div className="breadcrumb mt-2">
                <span className="home cursor-pointer" onClick={this.goToHomeScreen}>Home</span>
                <span className="breadcrumb-separator">&gt;</span>
                <span className="title-1 breadcrumb-chapter-title cursor-pointer" title={chapterTitle} onClick={this.goToChapter}>
                    {chapterTitle}
                </span>
                <span className="breadcrumb-separator">&gt;</span>
                <span className="title-1 breadcrumb-nowrap cursor-pointer" onClick={this.goToExamPrepKit}>Exam Prep Kit</span>
                <span className="breadcrumb-separator">&gt;</span>
                <span className="title-1 breadcrumb-nowrap cursor-pointer" onClick={this.goBackToTableOfContents}>Table of Contents</span>
                <span className="breadcrumb-separator">&gt;</span>
                <span className="title-1 breadcrumb-nowrap cursor-pointer" onClick={() => this.goToCaseStudyList()}>Prepare and Practice Case Study</span>
                <span className="breadcrumb-separator">&gt;</span>
                <span className="title-1 active breadcrumb-nowrap">{`Case Study Completed`}</span>
            </div>
        );
    }


    openPdf(url) {

        window.open('https://countingwell-public-content-prod.s3.ap-south-1.amazonaws.com/9b9957ae-ba01-4368-bca6-f725a34570c6_Tractor%20Case%20Study.pdf')

    }

    showNextCaseStudyQuestion() {
        this.props.delegate && this.props.delegate.showNextCaseStudyQuestion && this.props.delegate.showNextCaseStudyQuestion()
    }

    goToCaseStudyList() {
        this.props.caseStudyListDelegate && this.props.caseStudyListDelegate.hideStandardClassworkExperience && this.props.caseStudyListDelegate.hideStandardClassworkExperience()
    }


    render() {

        return (
            <div className="case-study-end-screen">
                <img className="header-image-size" src={getThemeImageSource(ImageConstants.HOMEWORK_COMPLETION_SCREEN_HEADER, this.state.categoryId)} />
                {this.renderBreadcrumb()}

                <div className="text-center great-message mt-5 mb-1">Case Study - {`${this.meta.caseStudyTitle}`} Completed!</div>
                <div>
                    <img className="divider-image-width" src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_HEADER_DIVIDER, this.categoryThemeId)}></img>
                </div>
                <div className="row ml-0 mr-0 justify-content-center">
                    <div className="col mt-4 ml-5">
                        <div className="chapter-title text-center mt-3">{this.chapterTitle}</div>
                        {/* <div className="lets-text text-center mt-2">Click on Insights to Look in to your scores</div>
                        <div className="revise-text text-center mt-2">Revise concepts for better scoring</div> */}
                        <div className="text-center">
                            <img className="workout-image-size mt-3" src={getThemeImageSource(ImageConstants.TAKE_CHALLENGE_POPUP_MALE_IMAGE, this.state.categoryId)} />
                        </div>
                        <div className="mt-5 d-flex justify-content-center align-items-center">
                            {
                                this.meta.showNextCaseStudyQuestionButton &&
                                <div className="button text-center ">
                                    <div className="cursor-pointer" onClick={() => this.showNextCaseStudyQuestion()}>
                                        {"Practice Next Case Study"}
                                    </div>
                                </div>
                            }

                            <div className="learning-gap-button text-center ml-4">
                                <div className="cursor-pointer" onClick={() => this.goToCaseStudyList()} >
                                    {"Go To Case Study List"}
                                </div>
                            </div>
                            {/* <div className="learning-gap-button text-center ml-4">
                                <div className="cursor-pointer" >
                                    {"Back to Prepare"}
                                </div>
                            </div> */}
                            <div className="insights-button text-center ml-4">
                                <div className="cursor-pointer" onClick={this.goBackToTableOfContents} >
                                    {"Back to Prepare"}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        )
    }
}
